export default __webpack_public_path__ + "static/media/clashing-edu-logo-currentColor-orange.ff9611b7.svg";